import SlideImage from "assets/home.png";
import { Arrow } from "assets/SVG";
import { Button, ButtonGroup, Col } from "react-bootstrap";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-scroll";
import "../styles/Home.css";
const Home = () => {


    return (
        <div>
            <Swiper
                className="swiper swiperHome"
                modules={[Navigation, EffectFade, Autoplay, Pagination]}
                effect="fade"
                speed={1000}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                slidesPerView={1}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
            >
                {slidesdata.map((sli, index) => (
                    <SwiperSlide key={index}>
                        <img className="slide1 position-relative" src={sli.image} alt="slide1" />
                        <div className="slideContent w-100 align-items-center text-center">
                            <div className="zoom w-100">
                                {sli.text}
                                {sli.button}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};
const TagComp =


    <Col md={5} xs={11} className="mx-auto mb-3">
        <h4 style={{ backgroundColor: "rgba(250, 164, 87, 0.8)", padding: "9px" }} className="rounded-pill railway">
            Transforming Spatial Experience
        </h4>
    </Col>




const ButtonComp = <ButtonGroup className="btn-group">
    <Link
        to="Connect"
        smooth={true}
        duration={500}
    >
        <Button
            className="btn-custom px-5"
        >
            <small>Learn More</small>
        </Button>
    </Link>
    <span className="arrow">
        <Arrow />
    </span>
</ButtonGroup>




const slidesdata = [
    {
        image: SlideImage,
        text: TagComp
        , button: ButtonComp
    },
    {
        image: SlideImage,
        text: TagComp
        , button: ButtonComp
    },
    {
        image: SlideImage,
        text: TagComp
        , button: ButtonComp
    },

];
export default Home;
